import React from 'react';
import FormContext, { FormManager } from '../context/FormManagerProvider';
import { useContext } from 'react';
import { FormInstance } from 'antd';

export default function useFormBuilder(form?: {
  instance: FormInstance;
  name: string;
  beforeValueSet?: (values: any) => any;
}): FormManager {
  const formManager: FormManager = useContext(FormContext);

  React.useEffect(() => {
    if (form) {
      formManager.addForm(form.instance, form.name);

      let initialValues = form.instance.getFieldsValue();
      let formModel = formManager.getFormModel(form.name);

      formModel.updateFormData({
        ...initialValues,
        ...formModel.formValues
      });

      let formInitialValues = formModel.formValues;

      if (form.beforeValueSet) {
        formInitialValues = form.beforeValueSet(formInitialValues);
      }

      // set initial values for the form
      form.instance.setFieldsValue(formInitialValues);

      return () => {
        formManager.removeForm(form.name);
      };
    }
  }, [formManager, form]);

  return formManager;
}
